import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCard, MatCardActions, MatCardContent, MatCardModule, MatCardTitle } from "@angular/material/card";
import { RouterLink } from '@angular/router';
import { MatomoService } from '@app/services/matomo.service';
import { NewsComponent } from '@components/news/news.component';
import { environment } from '@environments/environment';
import { AuthService } from '@services/auth.service';
import { ScopeCardComponent } from '../scope-card/scope-card.component';

/**
 * component which serves two purposes:
 *
 * 1. shown login button for unauthorized users
 * 2. shown launch scope button, when user is authorized
 *
 * @class HomeComponent
 * @typedef {HomeComponent}
 * @implements {OnInit}
 */
@Component( {
    selector: 'app-home',
    imports: [ NgClass, NewsComponent, ScopeCardComponent, MatCard, MatCardContent, MatCardTitle, MatCardActions, MatButtonModule, MatCardModule, RouterLink ],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
} )
export class HomeComponent {
    authService = inject( AuthService );
    #matomoService = inject( MatomoService );

    /** flags to control which modules should be shown */
    showCommunityHeroBanner = environment.optionalModules.showCommunityHeroBanner;
    showInsideScopeBanner = environment.optionalModules.showInsideScopeBanner;

    /** flag if feed posts got loaded */
    hasPosts = computed( () => this.hasBlogItems() || this.hasReleaseItems() );
    hasBlogItems = signal( true );
    hasReleaseItems = signal( true );

    heroBannerButtonLink = [ '/', 'scope-community' ];
    heroBannerButtonLabel = $localize`:@@home-hero-banner-button-label:Discover the Scope Community`;

    /**
   * Track banner clicks dynamically via MatomoService
   * @param bannerId ID or identifier of the clicked banner
   */
    trackBannerClick( event: Event, bannerId: string ) {
        // prevent event propagation of the link or the button
        //  to avoid tracking clicks twice
        event.stopPropagation();
        this.#matomoService.trackEvent( 'Inside Scope Banner 2026', 'Click Link', bannerId );
    }
}
